import { AxiosResponse } from 'axios';
import { LoginValidation } from '@/interfaces/login-validation.interface';

// login was successful is we are redirected to the previous conx-ui location
const validateLoginResponse = (response: AxiosResponse): LoginValidation => {
  // responseURL - final URL obtained after any redirects
  const redirectToCompanyDashboard = response.request.responseURL.includes('company-dashboard');
  return redirectToCompanyDashboard ?
    { loggedIn: true, redirectUrl: response.request.responseURL } :
    { loggedIn: response.request.responseURL.includes('frontend/site') };
};

const loginService = { validateLoginResponse };

export default loginService;
